module.exports = __webpack_public_path__ + "static/media/TwitterRound.61d24adf.svg";